<template>
  <div>
    <a-spin :spinning="isLoading">
      <a-row type="flex" justify="space-between" align="center">
        <h2>New Advertisement</h2>
      </a-row>
      <div class="grid grid-cols-6">
        <div class="col-span-6">
          <Form v-model="form" v-model:mediaType="mediaType"/>
        </div>
        <!-- <div class="col-span-2 pl-8 relative">
          <Ad />
        </div> -->
      </div>
      <div>
        <router-link to="/advertisements">
          <a-button>Cancel</a-button>
        </router-link>
        <a-button type="primary" @click="onSubmit" style="margin-left: 10px;"
          >Save</a-button
        >
        <a-button
          type="primary"
          @click="onSubmitAndKeep"
          style="margin-left: 10px;"
          >Save & Create other</a-button
        >
      </div>
    </a-spin>
  </div>
</template>

<script>
import Form from "@/components/Form";
// import Ad from "@/components/Ad";

export default {
  components: {
    Form,
    // Ad,
  },
  data() {
    return {
      isLoading: false,
      subindustries: null,
      mediaType: "drive",
      form: {
        visible: false,
        new: false,
        name: null,
        logo: null,
        collections: [],
        media_source: null,
        primary_text: null,
        headline: null,
        description: null,
        display_link: null,
        call_to_action: null,
        analysis: null,
        tags: [],
        industry: null,
        subindustry: null,
        type: null,
        seasonal: null,
        format: null,
        video_type: null,
        video_length: null,
        gender: null,
        objective: null,
        placement: false,
      },
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.createAdvertisement();
      if (success) {
        this.$router.push("/advertisements");
      }
    },
    async onSubmitAndKeep() {
      const { success } = await this.createAdvertisement();
      if (success) {
        this.$router.go(0);
      }
    },
    async createAdvertisement() {
      this.isLoading = true;

      const advertisement = await this.$store.dispatch(
        "CREATE_ADVERTISEMENT",
        this.form
      );
      if (this.mediaType == "file") {
        const media = await this.uploadFile(advertisement.data.id);
        this.isLoading = false;
        return media;
      }

      this.isLoading = false;
      return advertisement;
    },
    async uploadFile(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      formdata.append("folder", "media");
      formdata.append("file", this.form.media_source);
      return await this.$store.dispatch("UPLOAD_ADVERTISEMENT_MEDIA", formdata);
    },
  },
};
</script>

<style>
.advertisements__new__actions button ~ button,
.advertisements__new__actions a ~ a,
.advertisements__new__actions a ~ button,
.advertisements__new__actions button ~ a {
  margin-left: 10px;
}
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
.custom_select--group .ant-row.ant-form-item {
  margin-bottom: 0 !important;
}
</style>
